import './index.css';
const SIZES_SORTED = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
const getSizesMap = (sizes) => {
    const result = {
        xs: sizes.default,
        s: sizes.default,
        m: sizes.default,
        l: sizes.default,
        xl: sizes.default,
        xxl: sizes.default,
    };
    let prevGteSize = sizes.default;
    SIZES_SORTED.forEach((size) => {
        prevGteSize = sizes[`gte${size.charAt(0).toUpperCase()}${size.slice(1)}`] ?? prevGteSize;
        const currentSize = sizes[size] ?? prevGteSize;
        result[size] = currentSize;
    });
    return result;
};
const genCssVarsFromSizesMap = (sizes) => Object.entries(sizes).reduce((acc, [size, value]) => ({ ...acc, [`--magritte-spacing-${size}`]: `${value}px` }), {});

export { genCssVarsFromSizesMap, getSizesMap };
//# sourceMappingURL=utils.js.map
